<template>
  <a-modal
    title="操作"
    style="top: 20px;"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @ok="handleSubmit"
  >
    <a-form :form="form">
      <a-form-item style="display:none">
        <a-input v-decorator="['supplierId']" />
      </a-form-item>
      <a>基本信息</a>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商名称" style="position: relative">
        <span style="color: red;position: absolute;left: -92px;">*</span>
        <a-input v-model="supplierName" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="负责人" style="position: relative">
        <span style="color: red;position: absolute;left: -65px;">*</span>
        <a-input v-model="personCharge" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系方式" style="position: relative">
        <span style="color: red;position: absolute;left: -78px;">*</span>
        <a-input maxLength="11" v-model="phonenumber" />
      </a-form-item>

      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 所在省" style="position: relative">
        <span style="color: red;position: absolute;left: -65px;">*</span>
        <a-select @change="onChange" v-model="currentProvince">
          <a-select-option v-for="item in selectAllProvince" :value="item.provinceCode">{{
            item.provinceName
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所在市" style="position: relative">
        <span style="color: red;position: absolute;left: -65px;">*</span>
        <a-select v-model="currentCity">
          <a-select-option v-for="item in selectCityName" :value="item.cityCode">{{ item.cityName }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label=" 发货省" style="position: relative">
        <span style="color: red;position: absolute;left: -65px;">*</span>
        <a-select @change="onChange2" v-model="deliveryProvince">
          <a-select-option v-for="item in selectAllProvince" :value="item.provinceCode">{{
            item.provinceName
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货市" style="position: relative">
        <span style="color: red;position: absolute;left: -65px;">*</span>
        <a-select v-model="deliveryCity">
          <a-select-option v-for="item in selectCityName2" :value="item.cityCode">{{ item.cityName }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否开票" style="position: relative">
        <span style="color: red;position: absolute;left: -78px;">*</span>
        <a-select v-model="invoice">
          <a-select-option value="0">不开票</a-select-option>
          <a-select-option value="1">开票</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item v-if="invoice == 1" :labelCol="labelCol" :wrapperCol="wrapperCol" label="发票类型">
        <a-select v-model="invoiceType">
          <!--          <a-select-option value="0">无</a-select-option>-->
          <a-select-option value="1">增值税普票</a-select-option>
          <a-select-option value="2">增值税专票</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="税率承担方">
        <a-select v-model="taxpayer">
          <a-select-option value="0">供应商</a-select-option>
          <a-select-option value="1">锁安</a-select-option>
          <a-select-option value="2">双方</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="承担税点">
        <a-input-number v-model="taxPoint" :min="0" :step="0.01" />
      </a-form-item>

      <a>收款信息</a>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="户名">
        <a-input v-model="accountName" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="银行账号">
        <a-input
          autocomplete="off"
          v-decorator="['accountNumber', { rules: [{ validator: this.bankNum, required: false }] }]"
        />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="开户行">
        <!--<a-input v-model="bankName"/>-->
        <a-select
          showSearch
          optionFilterProp="children"
          v-model="bankName"
          :filterOption="filterOption"
          allowClear="true"
        >
          <a-select-option v-for="item of bankName1" :title="item.name" :key="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="付款方式">
        <a-select v-model="payment">
          <a-select-option value="0">先付款</a-select-option>
          <a-select-option value="1">后付款</a-select-option>
        </a-select>
      </a-form-item>

      <div><button type="button" @click="detailBtn">添加配件</button></div>
    </a-form>
    <a-modal
      title="配件详情"
      style="top: 20px;"
      :width="950"
      v-model="visible2"
      :confirmLoading="confirmLoading"
      :maskClosable="false"
      @ok="handleSubmit2"
    >
      <a-form>
        <a-row :gutter="16">
          <!--        <a-col :span="6">-->
          <!--          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件名称">-->
          <!--            <a-select  @change="onChange3" v-model="accessoryName">-->
          <!--              <a-select-option   v-for=" item in data2" :value="item.accessoryId">{{item.accessoryName}}</a-select-option>-->
          <!--            </a-select>-->
          <!--          </a-form-item>-->
          <!--        </a-col>-->
          <a-col :span="5">
            <a-button type="primary" ghost @click="handleadd1" :disabled="isDisable1">添加配件</a-button>
          </a-col>
        </a-row>

        <div v-for="(item2, i) in supplierAreas" :key="i">
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-item style="margin-left:-38px;" :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件名称">
                <a-select
                  :disabled="item2.supplierAccessory.status == true"
                  show-search
                  @change="onChange3(i)"
                  v-model="item2.supplierAccessory.accessoryId"
                  v-decorator="['accessoryId', { rules: [{ required: true, message: '配件名称' }] }]"
                >
                  <a-select-option :disabled="item.unityPrice == true" v-for="item in data2" :value="item.accessoryId"
                    >{{ item.accessoryType }} _ {{ item.accessoryName }} _ {{ item.accessoryCategory }} _
                    {{ item.accessorySpecification }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!--          <a-col :span="5">-->
            <!--                <p  style="color: red;margin-left: -50px;line-height: 36px;" v-if="item2.supplierAccessory.status"> * 配件名称重复</p>-->
            <!--           </a-col>-->
          </a-row>

          <a-row v-for="(item, ii) in supplierAreas[i].supplierUnities" :key="ii">
            <a-col :span="7">
              <a-form-item label="进货价" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input
                  v-model="item.price"
                  v-decorator="['price', { rules: [{ required: true, message: '进货价' }] }]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="8">
              <a-form-item label="数量区间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input placeholder="例如：200" @blur="blur(i, ii)" v-model="item.priceUnit" type="number" style="" />
              </a-form-item>
            </a-col>

            <a-col :span="5">
              <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="item.remark" maxlength="200" style="" />
              </a-form-item>
            </a-col>

            <a-col :span="4">
              <a-button type="danger" ghost @click="removeTab1(i, ii)" :disabled="isDisable3">删除</a-button>
              <a-button type="primary" ghost style="margin-left:5px" @click="handleadd2(i)">添加</a-button>
            </a-col>

            <div>
              <a-col :span="7">
                <a-form-item label="参考价" :labelCol="labelCol" :wrapperCol="wrapperCol" style="color: red">
                  <a-input v-model="item.price2" style="color: red" disabled="disabled" />
                </a-form-item>
              </a-col>
            </div>
          </a-row>
          <a-divider></a-divider>
        </div>
      </a-form>
    </a-modal>
  </a-modal>
</template>
<script>
import {
  countSupplierPrice,
  selectaccessory,
  saveSupplier,
  editsupplier,
  getonesupplier,
  selectAllProvince,
  selectCityName
} from '@/api/accessory/supplier'
import pick from 'lodash.pick'
export default {
  name: 'SupplierModal',
  props: {},
  components: {},
  data() {
    return {
      count: 1,
      supplierId: '',
      // 供应商名称
      supplierName: '',
      // 负责人
      personCharge: '',
      // 联系方式
      phonenumber: '',
      // 所在省
      currentProvince: '',
      // 所在市
      currentCity: '',
      // 发货省
      deliveryProvince: '',
      // 发货市
      deliveryCity: '',
      // 是否开票
      invoice: '',
      // 发票类型
      invoiceType: '',
      // 税率承担方
      taxpayer: '',
      // 承担税点
      taxPoint: '',
      // 开户名
      accountName: '',
      // 银行账号
      accountNumber: '',
      // 开户行
      bankName: '',
      // 付款方式
      payment: '',
      // 配件列表
      data2: '',
      // 配件名称
      accessoryName: '',
      // 配件
      supplierAreas: [],
      selectCityName2: '',
      selectAllProvince: '',
      selectCityName: '',
      province: '',
      visible: false,
      visible2: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      confirmLoading2: false,
      mdl: {},
      form: this.$form.createForm(this),
      bankName1: [
        { id: '中国工商银行', name: '中国工商银行' },
        { id: '中国银行', name: '中国银行' },
        { id: '中国建设银行', name: '中国建设银行' },
        { id: '中国农业银行', name: '中国农业银行' },
        { id: '交通银行', name: '交通银行' },
        { id: '中国邮政储蓄银行', name: '中国邮政储蓄银行' },
        { id: '招商银行', name: '招商银行' },
        { id: '上海浦东发展银行', name: '上海浦东发展银行' },
        { id: '民生银行', name: '民生银行' },
        { id: '兴业银行', name: '兴业银行' },
        { id: '中信银行', name: '中信银行' },
        { id: '平安银行', name: '平安银行' },
        { id: '光大银行', name: '光大银行' },
        { id: '华夏银行', name: '华夏银行' },
        { id: '广发银行', name: '广发银行' },
        { id: '上海银行', name: '上海银行' },
        { id: '南京银行', name: '南京银行' },
        { id: '渤海银行', name: '渤海银行' },
        { id: '江苏银行', name: '江苏银行' },
        { id: '恒丰银行', name: '恒丰银行' },
        { id: '徽商银行', name: '徽商银行' },
        { id: '国家开发银行', name: '国家开发银行' },
        { id: '上海农村商业银行', name: '上海农村商业银行' },
        { id: '农村信用社', name: '农村信用社' },
        { id: '农村合作银行', name: '农村合作银行' }
      ],

      formItemLayoutWithOutLabel: {
        wrapperCol: {
          xs: { span: 24, offset: 0 },
          sm: { span: 20, offset: 4 }
        }
      }
    }
  },
  beforeCreate() {
    this.form2 = this.$form.createForm(this, { name: 'dynamic_form_item' })
    this.form2.getFieldDecorator('keys', { initialValue: [], preserve: true })
  },
  created() {},
  computed: {},
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    filteredOptions(value) {
      return this.data2.filter(num => {
        return num.accessoryId != value
      })
    },

    //号正则表达式
    bankNum(rule, value, callback) {
      const pwdRegex = /^[1-9]\d{16,19}$/
      console.log(value)
      if (value == undefined || value.length == 0) {
        callback()
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入正确的银行卡号'))
      }
      callback()
    },
    // 失去焦点
    blur(index, rowIndex) {
      console.log(index)
      console.log(rowIndex)

      const unitPrice = {
        accessoryId: this.supplierAreas[index].supplierAccessory.accessoryId,
        priceUnit: this.supplierAreas[index].supplierUnities[rowIndex].priceUnit
      }
      console.log(this.supplierAreas[index].supplierUnities)
      // console.log(123)
      countSupplierPrice(unitPrice).then(res => {
        console.log(res)
        if (res.code == 0) {
          this.supplierAreas[index].supplierUnities[rowIndex].price2 = res.data
          console.log(this.supplierAreas[index].supplierUnities[rowIndex].price2)
        }
      })
    },

    // 获取焦点
    onFocus(e) {
      console.log(e)
      console.log(321)
    },
    onChange3(index) {
      console.log('data2', this.data2)
      for (let i in this.data2) {
        console.log('i', i)
        if (this.data2[i].accessoryId == this.supplierAreas[index].supplierAccessory.accessoryId) {
          // this.data2.push(i,1)
          this.data2[i].unityPrice = true

          // this.$message.success('不能重复选择')
          // for(let j=0;j<this.supplierAreas.length;j++){
          //   if(this.supplierAreas[j].supplierAccessory.accessoryId != this.supplierAreas[index].supplierAccessory.accessoryId){
          //     this.data2[i].unityPrice=false
          //   }
          // }
        }
      }
      this.supplierAreas[index].supplierAccessory.status = true
      console.log('data3', this.data2)
      // console.log(this.supplierAreas)
      //    for(let i=0;i<this.supplierAreas.length;i++){
      // if(this.supplierAreas[i].supplierAccessory.accessoryId == this.supplierAreas[index].supplierAccessory.accessoryId){
      //       if(this.count>3){
      //         this.$message.success('不能重复选择')
      //       }else{
      //         this.supplierAreas[index].supplierAccessory.accessoryId
      //       }
      // }else{
      //   this.supplierAreas[index].supplierAccessory.accessoryId
      // }
      //    }
      //    this.supplierAreas[index].supplierAccessory.accessoryId
      //    console.log( this.supplierAreas[index].supplierAccessory.accessoryId )
      //    // countSupplierPrice({}).then(res => {
      //    //   console.log(res)
      //    //   this.selectCityName = res.rows
      //    // })
      //    console.log(this.supplierAreas)
    },

    // 移除添加
    removeTab1(index, rowIndex) {
      // 当没有多余tab时就不再删除
      for (let i in this.data2) {
        console.log('i', i)
        if (this.data2[i].accessoryId == this.supplierAreas[index].supplierAccessory.accessoryId) {
          // this.data2.push(i,1)
          this.data2[i].unityPrice = false

          // this.$message.success('不能重复选择')
          // for(let j=0;j<this.supplierAreas.length;j++){
          //   if(this.supplierAreas[j].supplierAccessory.accessoryId != this.supplierAreas[index].supplierAccessory.accessoryId){
          //     this.data2[i].unityPrice=false
          //   }
          // }
        }
      }

      if (index == 0 && rowIndex !== 0) {
        if (rowIndex == 0) {
          this.$message.success('不能再刪除')
          // this.shortAdvertisingPosition[index].rows.splice(rowIndex, 1)
        } else {
          this.supplierAreas[index].supplierUnities.splice(rowIndex, 1)
        }
      } else {
        if (this.supplierAreas.length == 0) {
          this.$message.success('不能再刪除')
        } else {
          this.supplierAreas.splice(index, 1)
        }
      }
      this.count--
      console.log('删除', this.count)
    },

    // 添加单个
    handleadd2(index) {
      this.supplierAreas[index].supplierUnities.push({
        price: '',
        price2: '',
        priceUnit: '',
        remark: ''
      })
    },

    // 添加
    handleadd1(index) {
      this.supplierAreas.push({
        supplierAccessory: {
          accessoryId: '',
          status: false
        },
        supplierUnities: [
          {
            price2: '',
            price: '',
            priceUnit: '',
            remark: ''
          }
        ]
      })
      this.count++
      console.log('添加', this.count)
    },

    onChange(value) {
      var provinceCode = value
      this.currentCity = ''
      selectCityName({ provinceCode: provinceCode }).then(res => {
        console.log(res)
        this.selectCityName = res.rows
      })
    },

    onChange2(value) {
      this.deliveryCity = ''
      console.log(value)
      var provinceCode = value
      selectCityName({ provinceCode: provinceCode }).then(res => {
        console.log(res)
        this.selectCityName2 = res.rows
      })
    },

    add() {
      this.form.resetFields()
      // 供应商名称
      this.supplierName = ''
      // 负责人
      this.personCharge = ''
      // 联系方式
      this.phonenumber = ''
      // 所在省
      this.currentProvince = ''
      // 所在市
      this.currentCity = ''
      // 发货省
      this.deliveryProvince = ''
      // 发货市
      this.deliveryCity = ''
      // 是否开票
      this.invoice = ''
      // 发票类型
      this.invoiceType = ''
      // 税率承担方
      this.taxpayer = ''
      // 承担税点
      this.taxPoint = ''
      // 开户名
      this.accountName = ''
      // 银行账号
      this.accountNumber = ''
      // 开户行
      this.bankName = ''
      // 付款方式
      this.payment = ''
      // 配件列表
      this.data2 = ''
      // 配件名称
      this.accessoryName = ''
      // 配件
      this.supplierAreas = []
      this.selectAllProvince = ''
      this.selectCityName = ''
      this.province = ''

      this.form.resetFields()
      this.edit({ supplierId: 0 })
    },
    edit(record) {
      this.mdl = Object.assign(record)
      this.visible = true
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.mdl,
            'supplierName',
            'personCharge',
            'phonenumber',
            'currentProvince',
            'currentCity',
            'deliveryProvince',
            'deliveryCity',
            'invoice',
            'invoiceType'
          )
        )
      })
      this.supplierId = record.supplierId
      selectAllProvince().then(res => {
        console.log(res)
        this.selectAllProvince = res.rows
        this.selectAllProvince2 = res.rows
      })
      if (record.supplierId != 0) {
        getonesupplier({ supplierId: record.supplierId }).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.record2 = res.data
            this.supplierName = res.data.supplierName
            // 负责人
            this.personCharge = res.data.personCharge
            // 联系方式
            this.phonenumber = res.data.phonenumber
            // 所在省
            this.currentProvince = res.data.currentProvince
            // 所在市
            this.currentCity = res.data.currentCity
            // 发货省
            this.deliveryProvince = res.data.deliveryProvince
            // 发货市
            this.deliveryCity = res.data.deliveryCity
            // 是否开票
            this.invoice = res.data.invoice
            // 发票类型
            this.invoiceType = res.data.invoiceType
            // 税率承担方
            this.taxpayer = res.data.taxpayer
            // 承担税点
            this.taxPoint = res.data.taxPoint
            // 开户名
            this.accountName = res.data.accountName
            // 银行账号
            this.form.setFieldsValue({
              accountNumber: res.data.accountNumber
            })

            selectCityName({ provinceCode: res.data.currentProvince }).then(res => {
              console.log(res)
              this.selectCityName = res.rows
            })
            selectCityName({ provinceCode: res.data.deliveryProvince }).then(res => {
              console.log(res)
              this.selectCityName2 = res.rows
            })
            // 开户行
            this.bankName = res.data.bankName
            // 付款方式
            this.payment = res.data.payment
            // 配件
            this.supplierAreas = res.data.supplierAreas
          } else {
            this.$message.error('系统错误，请稍后再试')
          }
        })
      }
    },

    detailBtn() {
      this.visible2 = true
      this.count++
      console.log('添加配件', this.count)
      selectaccessory().then(res => {
        console.log(res)
        this.data2 = res.rows
      })
    },

    handleSubmit2() {
      console.log(this.supplierUnities)
      console.log(this.supplierAreas)
      for (let k = 0; k < this.supplierAreas.length; k++) {
        this.supplierAreas[k].supplierAccessory.status = false
      }
      for (let i = 0; i < this.supplierAreas.length - 1; i++) {
        for (let j = i + 1; j < this.supplierAreas.length; j++) {
          if (
            this.supplierAreas[i].supplierAccessory.accessoryId ===
              this.supplierAreas[j].supplierAccessory.accessoryId &&
            this.supplierAreas[i].supplierAccessory.accessoryId != '' &&
            this.supplierAreas[j].supplierAccessory.accessoryId != ''
          ) {
            this.supplierAreas[i].supplierAccessory.status = true
            this.supplierAreas[j].supplierAccessory.status = true

            return this.$message.error('配件名称重复有重复')
            // this.$message.error('第'+(i+1)+'条配件名称重复和第'+(j+1)+'条配件名称重复')
          }
        }
      }
      // for(let i in this.supplierAreas){
      //   if(this.supplierAreas[i]){
      //
      //   }
      //     console.log(i)
      // }
      if (this.validator(1)) {
        return
        // this.visible2 = true
      } else {
        this.visible2 = false
      }
    },

    handleSubmit() {
      if (this.validator()) {
        return
      } else {
        const values = {
          supplierName: this.supplierName,
          personCharge: this.personCharge,
          phonenumber: this.phonenumber,
          currentProvince: this.currentProvince,
          currentCity: this.currentCity,
          deliveryProvince: this.deliveryProvince,
          deliveryCity: this.deliveryCity,
          invoice: this.invoice,
          invoiceType: this.invoiceType,
          taxpayer: this.taxpayer,
          taxPoint: this.taxPoint,
          accountName: this.accountName,
          accountNumber: this.form.getFieldValue('accountNumber'),
          bankName: this.bankName,
          payment: this.payment,
          supplierAreas: this.supplierAreas,
          supplierId: this.supplierId
        }
        if (this.supplierId != undefined && this.supplierId != 0) {
          editsupplier(values)
            .then(res => {
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.$emit('ok', 1)
                this.visible = false
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        } else {
          saveSupplier(values)
            .then(res => {
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.$emit('ok', 2)
                this.visible = false
              } else {
                this.$message.success(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      }
    },
    // 判断
    validator(val) {
      console.log(val, '判断')
      if (val == 1) {
        for (let i = 0; i < this.supplierAreas.length; i++) {
          if (
            this.supplierAreas[i].supplierAccessory.accessoryId == '' ||
            this.supplierAreas[i].supplierAccessory.accessoryId == null ||
            this.supplierAreas[i].supplierAccessory.accessoryId == undefined
          ) {
            this.$message.success('配件名称不能为空')
            return true
          }
        }
        for (let i = 0; i < this.supplierAreas.length; i++) {
          for (let j = 0; j < this.supplierAreas[i].supplierUnities.length; j++) {
            if (
              this.supplierAreas[i].supplierUnities[j].price == '' ||
              this.supplierAreas[i].supplierUnities[j].price == null ||
              this.supplierAreas[i].supplierUnities[j].price == undefined
            ) {
              this.$message.success('进货价不能为空')
              return true
            }
            if (
              this.supplierAreas[i].supplierUnities[j].priceUnit == '' ||
              this.supplierAreas[i].supplierUnities[j].priceUnit == null ||
              this.supplierAreas[i].supplierUnities[j].priceUnit == undefined
            ) {
              this.$message.success('数量区间不能为空')
              return true
            }
          }
        }
      } else {
        if (this.supplierName == '' || this.supplierName == null || this.supplierName == undefined) {
          this.$message.success('供应商名称不能为空')
          return true
        }

        if (this.personCharge == '' || this.personCharge == null || this.personCharge == undefined) {
          this.$message.success('负责人不能为空')
          return true
        }

        if (this.phonenumber == '' || this.phonenumber == null || this.phonenumber == undefined) {
          this.$message.success('联系方式不能为空')
          return true
        } else if (!/^1[3456789]\d{9}$/.test(this.phonenumber)) {
          this.$message.success('手机号码有误，请重填')
          return true
        }

        if (this.currentProvince == '' || this.currentProvince == null || this.currentProvince == undefined) {
          this.$message.success('所在省不能为空')
          return true
        }

        if (this.currentCity == '' || this.currentCity == null || this.currentCity == undefined) {
          this.$message.success('所在市不能为空')
          return true
        }

        if (this.deliveryProvince == '' || this.deliveryProvince == null || this.deliveryProvince == undefined) {
          this.$message.success('发货省不能为空')
          return true
        }

        if (this.deliveryCity == '' || this.deliveryCity == null || this.deliveryCity == undefined) {
          this.$message.success('发货市不能为空')
          return true
        }

        if (this.invoice == '' || this.invoice == null || this.invoice == undefined) {
          this.$message.success('是否开票不能为空')
          return true
        }

        // if (this.invoiceType == '' || this.invoiceType == null || this.invoiceType == undefined) {
        //   this.$message.success('发票类型不能为空')
        //   return true
        // }

        // if (this.taxpayer == '' || this.taxpayer == null || this.taxpayer == undefined) {
        //   this.$message.success('税率承担方不能为空')
        //   return true
        // }
        //
        // if (this.taxPoint == '' || this.taxPoint == null || this.taxPoint == undefined) {
        //   this.$message.success('承担税点不能为空')
        //   return true
        // }

        // if (this.accountName == '' || this.accountName == null || this.accountName == undefined) {
        //   this.$message.success('开户名不能为空')
        //   return true
        // }

        // if (this.accountNumber == '' || this.accountNumber == null || this.accountNumber == undefined) {
        //   this.$message.success('银行账号不能为空')
        //   return true
        // }
        //
        // if (this.bankName == '' || this.bankName == null || this.bankName == undefined) {
        //   this.$message.success('开户行不能为空')
        //   return true
        // }
        //
        // if (this.payment == '' || this.payment == null || this.payment == undefined) {
        //   this.$message.success('付款方式不能为空')
        //   return true
        // }
      }
    }
  },

  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  }
}
</script>
